import { ArrowUp } from "lucide-react";
import { profile } from "@/data/profile";
import { scrollToTop } from "@/lib/scroll";

export function Footer() {
  return (
    <footer className="border-t border-line" data-testid="footer">
      <div className="container-x flex flex-col gap-10 py-14 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-display text-3xl font-bold tracking-[0.18em]">{profile.name.toUpperCase()}</p>
          <p className="mt-3 font-mono text-[10px] tracking-[0.25em] text-muted">C# / .NET · AI · ENGINEERING</p>
        </div>
        <div className="font-mono text-[10px] leading-loose tracking-[0.2em] text-muted">
          <p>© 2026 {profile.name.toUpperCase()}</p>
          <p>BUILT WITH REACT · GSAP · THREE.JS</p>
        </div>
        <button
          onClick={scrollToTop}
          className="flex h-12 w-12 items-center justify-center border border-line transition hover:text-accent"
          aria-label="Back to top"
          data-testid="back-to-top"
        >
          <ArrowUp size={18} aria-hidden="true" />
        </button>
      </div>
    </footer>
  );
}
